import {isNotNilOrEmpty} from 'ramda-adjunct';

import {getTestDrive} from '../../../utils/getTestDrive';

type TestDriveData = NonNullable<ReturnType<typeof getTestDrive>>;

export function hasTestDriveDetailedData(testDrive: TestDriveData): boolean {
  return [
    testDrive.title.testDriveDate,
    testDrive.title.driver,
    testDrive.content.driveStart,
    testDrive.content.driveEnd,
    testDrive.content.distance?.value,
    testDrive.content.maxSpeed?.value,
    testDrive.content.avgSpeed?.value,
  ].some(isNotNilOrEmpty);
}
